// eslint-disable-next-line validate-filename/naming-rules -- name is required for Next.js
'use client'

import { ErrorHandler } from 'ui/components/ErrorHandler'
import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'
import { Logo } from '@/components/Logo'

function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en">
      <body>
        <ErrorHandler error={error} reset={reset}>
          <Logo />
        </ErrorHandler>
      </body>
    </html>
  )
}

// eslint-disable-next-line import/no-default-export -- Next.js default policy
export default GlobalError
